// import request from '../shared/lib/request';
import constants from '../shared/constants';
import requestWrapper from '../shared/lib/requestWrapper';

async function create(payload) {
    var response = await requestWrapper({
        url:    '/AppointmentCompanion',
        method: 'POST',
        data: payload.data,
        baseURL: constants.sdn.baseUrl,
        notifications: payload.notifications
    });

    return response;
}

async function remove(payload) {
    var response = await requestWrapper({
        url:    '/AppointmentCompanion/' + payload.data.id,
        method: 'DELETE',
        baseURL: constants.sdn.baseUrl,
        notifications: payload.notifications
    });

    return response;
}

async function search(payload) {
    var response = await requestWrapper({
        url:    '/AppointmentCompanion/search',
        method: 'POST',
        data: payload.data,
        baseURL: constants.sdn.baseUrl,
        notifications: payload.notifications
    });

    return response;
}

const AppointmentService = {
    create, remove, search
}

export default AppointmentService;